import { render, staticRenderFns } from "./movieRecent.vue?vue&type=template&id=0ccfac66&scoped=true"
import script from "./movieRecent.vue?vue&type=script&lang=js"
export * from "./movieRecent.vue?vue&type=script&lang=js"
import style0 from "./movieRecent.vue?vue&type=style&index=0&id=0ccfac66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccfac66",
  null
  
)

export default component.exports